import API from '@/shared/plugins/Api/API'

class BuildsV3 extends API {
  constructor (id) {
    super(id)
    this.prefix = '/public/v1'
  }

  _appUrl (appName) {
    return `${this.prefix}/application/${encodeURIComponent(appName)}`
  }

  _tagUrl (appName, tagName) {
    return `${this._appUrl(appName)}/tag/${encodeURIComponent(tagName)}`
  }

  async listAll (params = {}) {
    const response = await this.request({
      method: 'get',
      url: `${this.prefix}/build`,
      params
    })
    return response
  }

  async listByApp (appName, params = {}) {
    const response = await this.request({
      method: 'get',
      url: `${this._appUrl(appName)}/build`,
      params
    })
    return response
  }

  async list (appName, tagName) {
    return this.request({
      method: 'get',
      url: `${this._tagUrl(appName, tagName)}/build`
    })
  }

  async getByUuid (appName, tagName, uuid) {
    return this.request({
      method: 'get',
      url: `${this._tagUrl(appName, tagName)}/build/${encodeURIComponent(uuid)}`
    })
  }

  async getLogs (appName, tagName, uuid) {
    const response = await this.request({
      method: 'get',
      url: `${this._tagUrl(appName, tagName)}/build/${encodeURIComponent(uuid)}/log`
    })
    return response?.logs ?? []
  }

  async start (appName, tagName) {
    return this.request({
      method: 'post',
      url: `${this._tagUrl(appName, tagName)}/build`
    })
  }

  async stop (appName, tagName) {
    await this.request({
      method: 'post',
      url: `${this._tagUrl(appName, tagName)}/build/stop`
    })
  }
}

export default BuildsV3
